
export class EventParticipantPriceResponse {
    
    constructor(data) {       

        this.currency = data && data.currency ? data.currency : '';      
        this.price = data && data.price !== undefined ? data.price : '';  
    }
}